(() => {
  'use strict';

  const storeCurrency =
    window.themeVariables?.settings?.storeCurrency ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'BRL';

  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
    style: 'currency',
    currency: storeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const money = (value) => formatter.format(value);

  function parseMoney(text) {
    let value = String(text || '').replace(/\u00a0/g, ' ').replace(/[^0-9,.-]/g, '');
    if (!value) return Number.NaN;

    const comma = value.lastIndexOf(',');
    const dot = value.lastIndexOf('.');

    if (comma > dot) value = value.replace(/\./g, '').replace(',', '.');
    else if (comma > -1 && dot > comma) value = value.replace(/,/g, '');
    else if (comma > -1) value = value.replace(',', '.');

    return Number.parseFloat(value);
  }

  function updateSaleBadge(root, base) {
    const productInfo = root.closest('.product-info');
    const badge = productInfo?.querySelector('on-sale-badge[discount-mode]');
    const comparison = parseMoney(productInfo?.querySelector('compare-at-price')?.textContent);
    const template = window.themeVariables?.strings?.discountBadge;
    if (!badge || !Number.isFinite(comparison) || typeof template !== 'string') return;

    badge.hidden = comparison <= base;
    if (badge.hidden) return;

    const savings = badge.getAttribute('discount-mode') === 'percentage'
      ? `${Math.round((comparison - base) * 100 / comparison)}%`
      : formatter.formatToParts(comparison - base)
        .filter((part) => part.type !== 'currency')
        .map((part) => part.value).join('').trim();
    const label = document.createElement('template');
    label.innerHTML = template.replace('@@', savings);
    badge.textContent = label.content.textContent.trim();
  }

  function updatePaymentSummary(root, base) {
    if (!root || !Number.isFinite(base)) return;

    updateSaleBadge(root, base);

    const rows = root.querySelectorAll('[data-installment-row]');
    rows.forEach((row) => {
      const count = Number(row.dataset.installments);
      const installmentFactor = Number(row.dataset.installmentFactor);
      const totalFactor = Number(row.dataset.totalFactor);

      if (!Number.isInteger(count) || count < 1 || count > 12 || !Number.isFinite(installmentFactor)) return;

      const value = row.querySelector('[data-installment-value]');
      const total = row.querySelector('[data-installment-total]');
      const installmentValue = base * installmentFactor / count;

      if (value) value.textContent = money(installmentValue);
      if (total && Number.isFinite(totalFactor)) total.textContent = money(base * totalFactor);
    });

    const lastRow = rows[rows.length - 1];
    const maxPrice = root.querySelector('[data-max-installment-price]');
    const lastValue = lastRow?.querySelector('[data-installment-value]');
    if (maxPrice && lastValue) maxPrice.textContent = lastValue.textContent;

    const pix = root.querySelector('[data-pix-price]');
    const savings = root.querySelector('[data-pix-savings]');
    if (pix || savings) {
      const discount = Number(root.dataset.pixDiscount || 0);
      const amount = base * discount / 100;
      if (pix) pix.textContent = money(base - amount);
      if (savings) savings.textContent = money(amount);
    }
  }

  function updateProductCard(card) {
    if (!card) return;

    const row = card.querySelector('.product-card__payment-summary[data-installment-factor]');
    const salePrice = card.querySelector('price-list sale-price, sale-price');
    const price = parseMoney(salePrice?.textContent);

    if (!row || !Number.isFinite(price)) return;

    const value = row.querySelector('[data-installment-value]');
    const count = Number(row.dataset.installments);
    const factor = Number(row.dataset.installmentFactor);
    if (value && count > 0 && Number.isFinite(factor)) value.textContent = money(price * factor / count);
  }

  document.addEventListener('variant:change', (event) => {
    const cents = Number(event.detail?.variant?.price);
    if (!Number.isFinite(cents)) return;

    const section = event.target?.closest?.('.product-info') || event.target?.closest?.('.shopify-section');
    if (!section) return;

    const base = cents / 100;
    section.querySelectorAll('[data-payment-summary]').forEach((root) => {
      updatePaymentSummary(root, base);
    });
  });

  document.addEventListener('change', (event) => {
    const card = event.target.closest?.('product-card');
    if (!card) return;

    requestAnimationFrame(() => updateProductCard(card));
  });

  document.querySelectorAll('[data-payment-summary]').forEach((root) => {
    const productInfo = root.closest('.product-info');
    const priceList = productInfo?.querySelector('price-list');
    const refresh = () => {
      const price = parseMoney(productInfo?.querySelector('price-list sale-price, sale-price')?.textContent);
      if (Number.isFinite(price)) updatePaymentSummary(root, price);
    };

    refresh();
    if (priceList) {
      const observer = new MutationObserver(refresh);
      observer.observe(priceList, { childList: true, characterData: true, subtree: true });
    }
  });
})();
